import React, { FC } from 'react';
import CarUnavailable from '../../assets/images/carUnavailable.png';
import imageContainer from './imageContainerStyles';
import FitImage from '../image/FitImage';

export interface IImageContainer {
  src: string;
  aspectRatio?: number;
  alt: string;
  onClick: () => void;
}

const ImageContainer: FC<IImageContainer> = ({ src, aspectRatio, alt, onClick }) => {
  const styles = imageContainer();

  return (
    <FitImage
      onClick={onClick}
      className={styles.carImage}
      src={src}
      color="transparent"
      animationDuration={0}
      aspectRatio={aspectRatio}
      dataTest={'image:model'}
      alt={alt}
      style={{ width: '100%', paddingTop: '50%' }}
      errorIcon={
        <img
          src={CarUnavailable}
          className={styles.imageUnavailable}
          alt="Unavailable car image"
          data-test={'image:model:unavailable'}
        />
      }
    />
  );
};

export default ImageContainer;
